module.exports = __webpack_public_path__ + "cf75d21a545b0657c42320325e8c7057.png";